import React, { Component, ReactNode } from 'react';
import Icon from '../../../../icons/Icon';
import { changePagePath, changeSidebarCollapse } from '../../../../redux/actions/PageActions';
import PageUtil from '../../../../util/PageUtil';
import CustomDismissible from '../../CustomDismissible';
import KeycloakStore from '../../../../config/KeycloakStore';
import UserService from '../../../../service/UserService';
import ServiceContainer from '../../../../config/ServiceContainer';
import { ServiceNames } from '../../../../constant/ServiceNames';
import { RootState } from '../../../../redux/store';
import { User } from '../../../../domain/rbac/RbacDomains';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { setUser } from '../../../../redux/actions/UserActions';
import { createPortal } from 'react-dom';
import ProfileComponentItem from './ProfileComponentItem';
import LanguageUtil from '../../../../util/LanguageUtil';
import RiskTypeUtil from '../../../../util/RiskTypeUtil';

class ProfileComponent extends Component<Props, State> {
  public state = new State();

  private readonly userService: UserService = ServiceContainer.getInstance().get(ServiceNames.USER);

  public render(): ReactNode {
    const { isOpen } = this.state;
    return (
      <CustomDismissible id={'profile-container'} onDismiss={() => this.setState({ isOpen: false })}>
        <div id={'profile-container'} onClick={() => this.setState({ isOpen: !isOpen })} className={'flex cursor-pointer items-center justify-center relative'}>
          <span className={'flex items-center w-8 h-8 bg-[#E3E9FC] rounded-full justify-center'} data-testid='profile_container_button'>
            <p className={'text-md'}>{this.getAvatarCharacter()}</p>
          </span>
          <span>
            <Icon icon={'arrow-down'} className={'text-white'} size={20} />
          </span>
          <div
            style={{ boxShadow: '0px 4px 6px -2px #00000008,0px 12px 16px -4px #00000014' }}
            className={`flex-col z-[1002] bg-white rounded-[8px] border border-[##E0E4E8] items-center justify-center absolute top-8 right-0 ${isOpen ? 'flex' : 'hidden'}`}
          >
            {createPortal(
              <div className={`top-0 left-0 h-full w-full bg-[#111111] z-[1001] opacity-30 ${this.state.isOpen ? 'fixed' : 'hidden'}`}></div>,
              document.body,
            )}
            {this.getUserItem()}
            {this.getSwitchUserItem()}
            {this.getViewProfileItem()}
            {this.getLogoutItem()}
          </div>
        </div>
      </CustomDismissible>
    );
  }

  private getUserItem = () => {
    const item = {
      icon: <div className={'w-8 h-8 flex items-center justify-center rounded-full bg-secondary'}>{this.getAvatarCharacter()}</div>,
      label: this.props.user.username,
      secondLabel: this.props.user.email,
      href: '',
      onClick: (event: any) => {
        event.preventDefault();
        event.stopPropagation();
      },
    };
    return <ProfileComponentItem icon={item.icon} label={item.label} href={item.href} onClick={item.onClick} secondLabel={item.secondLabel} />;
  };

  private getSwitchUserItem = () => {
    const { user } = this.props;
    const activeRiskType = user.activeRiskType;
    if (user.riskType != 'all') return;
    const fraudBoxShadow = activeRiskType == 'fraud' ? '1px 1px 3px 0px #00000014' : 'none';
    const complianceBoxShadow = activeRiskType == 'compliance' ? '1px 1px 3px 0px #00000014' : 'none';
    return (
      <div className={'flex w-full h-full items-center justify-center p-1.5 gap-x-3 bg-white'}>
        <div className={'flex w-full bg-[#F7F8FA] p-1 rounded-[3px}'}>
          <button
            onClick={() => this.changeActiveRiskType()}
            disabled={activeRiskType == 'fraud'}
            style={{ boxShadow: fraudBoxShadow }}
            className={`${activeRiskType == 'fraud' && 'bg-white'} flex w-full h-full items-center justify-center rounded-[3px] text-f-black-1 p-1`}
          >
            Fraud
          </button>
          <button
            onClick={() => this.changeActiveRiskType()}
            disabled={activeRiskType == 'compliance'}
            style={{ boxShadow: complianceBoxShadow }}
            className={`${activeRiskType == 'compliance' && 'bg-white'} flex w-full h-full items-center justify-center rounded-[3px] text-f-black-1 p-1`}
          >
            Compliance
          </button>
        </div>
      </div>
    );
  };

  private getViewProfileItem = () => {
    const item = {
      icon: <Icon icon={'people'} className={'text-f-black-2'} size={20} />,
      label: LanguageUtil.get({ id: 'common.label.viewProfile', defaultMessage: 'View Profile' }),
      onClick: () => {
        changePagePath([
          {
            title: 'Account',
            path: 'account',
            type: 'category',
            categoryId: 'Main',
            payload: PageUtil.calculateDefaultCategory(),
          },
        ]);
      },
      href: 'account',
    };
    return <ProfileComponentItem icon={item.icon} label={item.label} href={item.href} onClick={item.onClick} />;
  };

  private getLogoutItem = () => {
    const item = {
      icon: <Icon icon={'logout'} className={'text-f-black-2'} size={20} />,
      label: LanguageUtil.get({ id: 'common.label.logout', defaultMessage: 'Logout' }),
      href: '',
      onClick: () => {
        this.logOut();
      },
    };
    return <ProfileComponentItem icon={item.icon} label={item.label} href={item.href} onClick={item.onClick} />;
  };

  private getAvatarCharacter = (): string => {
    const { user } = this.props;
    if (user.firstName != undefined && user.firstName != '' && user.lastName != undefined && user.lastName != '') {
      return (user.firstName?.substring(0, 1) || '') + (user.lastName?.substring(0, 1).toUpperCase() || '');
    } else {
      return user.username.substring(0, 1) || '';
    }
  };

  private changeActiveRiskType = async () => {
    await this.userService.changeActiveRiskType();
    RiskTypeUtil.handleRiskTypeChange(this.props.user.activeRiskType);
  };

  private logOut = async () => {
    localStorage.removeItem('state');
    localStorage.removeItem('react-refresh-token');
    localStorage.removeItem('sub');
    localStorage.removeItem('react-token');
    KeycloakStore.getKeycloakInstance()?.logout();
    await this.userService.logout();
  };
}

class State {
  isOpen: boolean = false;
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  user: state.auth.user as User,
});
const mapDispatchToProps = { changeSidebarCollapse, changePagePath, setUser };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(ProfileComponent);
